<template>
  <v-app>
    <header class="header">
      <div class="header__side header__side--left">
        <UserInfo v-if="$route.path === '/profile'"/>
      </div>

      <a href="https://www.stokecityfc.com/" class="header__logo">
        <img src="./assets/logo.jpg" height="98" width="84" class="logo" alt="Stoke City FC" />
      </a>

      <div class="header__side header__side--right">
        <div class="mini-nav" v-if="ticketingRedirect">
          <ul v-if="miniNavTicketingEnabled">
            <li><a v-on:click="redirectToTicketing()" class="web-link">Return to Ticketing</a></li>
          </ul>
        </div>
        <nav class="mini-nav" v-else-if="$route.path === '/profile' && appLogin === false">
          <p class="mini-nav__title">Stoke City Official Websites</p>
          <ul>
            <li><a href="https://www.stokecityfc.com/" class="web-link">Official website</a></li>
            <li><a href="https://store.stokecityfc.com/" class="web-link">Online store</a></li>
            <li><a href="https://tickets.stokecityfc.com/" class="web-link">Ticketing</a></li>
          </ul>
        </nav>
      </div>
    </header>
    
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue'
//import Vuetify from 'vuetify'
import CognitoPlugin from './cognito-plugin.js'
import VueCookie from 'vue-cookie'
import UserInfo from '@/components/UserInfo'

import Vuetify, {
  VApp, // required
  VAlert,
  VTabs,
} from 'vuetify/lib'

import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VTabs,
  },
  directives: {
    Ripple
  }
})

Vue.use(CognitoPlugin)
Vue.use(VueCookie)
Vue.use(require('vue-moment'));

export default {
  name: 'App',
  components: {
    UserInfo
  },
  data () {
    return {
      loggedIn: false,
      referrer: null,
      appLogin: false,
      ticketingRedirect: null,
      miniNavTicketingEnabled: false,
      trusted: ['stokefcpayments.streamamg.com', 'stokecityfc.com', 'retailsportssystems.com']
    }
  },
  mounted () {
    console.log(window.location.href)
    if(localStorage.appLogin === 'true'){
      this.appLogin = true
    }

    // simple referral tracking (deprecated)
    if(window.location.href.includes("referred=1")){ //if the user is referred from a partner site
      localStorage.referrer = document.referrer
    }

    var urlPieces = window.location.href.split("returnUrl=") 
    // JWT return tracking from trusted Domains


    if(window.location.href.includes("returnUrl=")) { //if the user is referred from the StreamAMG payments site
      
      console.log('returnUrl requested')
      var trustedSource = false
      this.trusted.forEach(domain => {
        if(urlPieces[1].includes(domain)){
          trustedSource = true
          console.log(domain, 'is trusted')
        } 
      });
      
      if(trustedSource === true) {
        console.log('Trusted returnUrl set', window.location.href)
        localStorage.returnUrl = decodeURIComponent(urlPieces[1])
        if(window.location.href.includes("sendToken=false")){
          localStorage.suppressToken = "true"
        } else {
          localStorage.removeItem('suppressToken');
        }
      } else {
        console.log('returnUrl NOT from trusted domain')
      }
    } else {
      console.log('returnUrl NOT requested')
    }

    if(typeof localStorage.returnUrl != 'undefined'){
      if(localStorage.returnUrl.includes('ticket')){
        this.ticketingRedirect = localStorage.returnUrl
      }
    }
    //Upon initial mount we check the authentication state
    console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          if(userData['custom:privacy_accepted'] === 'true'){
            console.log('Access Check', 'privacy accepted')
            this.loggedIn = true;
            //always force logged in users to their profile, unless they are already going there
            this.$router.push("/profile");
            
          }else{
            console.log('Access Check', 'privacy NOT previously accepted')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      } 
    
    
  },
  methods: {
    redirectToTicketing (){
      var redirectTo = localStorage.returnUrl
      localStorage.returnUrl = ''
      window.location = redirectTo
    }
  },
  
  watch: {
    '$route' (to) {
      //Upon each route change we check the authentication state
      
      if(localStorage.appLogin === 'true'){
        this.appLogin = true
      }

      console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          if(userData['custom:privacy_accepted'] === 'true'){
            console.log('Access Check', 'privacy accepted')
            // tell the app that we've finished loading
            if(to.path!='/profile'){
              this.loggedIn = true;
              //always force logged in users to their profile, unless they are already going there
              this.$router.push("/profile");
            }
          }else{
            console.log('Access Check', 'privacy NOT previously accepted')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      }
    }
  }
}
</script>

<style lang="scss">
  @import '/css/global.scss';
</style>

<style lang="scss" scoped>
  /*
    Three-slot header: [account] [crest] [links].
    The two side slots share the leftover space equally (flex: 1 1 0), which is
    what keeps the crest optically centred whether or not the side slots have
    any content in them — no negative margins required.
  */
  .header {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 20px 0;
    margin: 0 auto 35px;
  }

  .header__logo {
    order: -1; // crest takes the full first row, the two blocks share the next
    display: flex;
    flex: 0 0 100%;
    justify-content: center;
    line-height: 0;
  }

  .header__side {
    display: flex;
    flex: 0 0 50%;
  }

  .header__side--left {
    justify-content: flex-start;
    padding: 0 10px 0 0;
  }

  .header__side--right {
    justify-content: flex-end;
    padding: 0 0 0 10px;
  }

  // only a populated slot opens up a gap below the crest
  .header__side:not(:empty) {
    margin: 20px 0 0;
  }

  .button-home {
    display: none;
  }

  @media screen and (min-width: 700px) {
    .header {
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      // stays tight just above the breakpoint, where the columns are narrowest
      padding: 48px 24px;
    }

    .header__logo {
      order: 0;
      flex: 0 0 auto;
      // symmetric, so the crest stays centred; stays modest just above the
      // breakpoint, where the columns have no width to spare
      margin: 0 16px;
    }

    // equal columns either side of the crest, each pushing its content out to
    // the page edge and away from the centre
    .header__side,
    .header__side:not(:empty),
    .header__side--left,
    .header__side--right {
      flex: 1 1 0;
      margin: 0;
      padding: 0;
    }

    .header__side--left {
      justify-content: flex-start;
    }

    .header__side--right {
      justify-content: flex-end;
    }

    .button-home {
      display: block;
    }
  }

  @media screen and (min-width: 960px) {
    .header {
      padding: 48px 64px;
    }

    .header__logo {
      margin: 0 64px;
    }
  }

  @media screen and (min-width: 1264px) {
    .header {
      max-width: 1600px; // stops the two blocks drifting apart on ultrawide screens
      padding: 48px 100px;
    }
  }

  .mini-nav {
    max-width: 250px;
  }
  .mini-nav li{
    list-style: none
  }
  .mini-nav__title {
    margin: 0 0 6px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
  }
  .web-link{
      display: inline-block;
      padding: 0;
      margin: 0 2px 0 0;
      color: #D7172F;
      font-size: 12px;
      line-height: 1.7;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
  }
  .page-title{
    color: #D7172F;
      font-size: 44px;
    text-align: left;
  }
</style>
